import { API, graphqlOperation } from "aws-amplify";
import { updateRequests } from "../graphql/mutations";
import moment from 'moment';

import {
  dateTimeStr
} from "./format";

const sandbox_promotionId = "2345f0aa-db7a-42b9-807b-9e8a82b81ae3";
const prod_promotionId =  "26d09475-32ec-448c-bb43-9f70aea55644";
const host = window.location.host;

export const refreshToken = async (clientId, token) => {
  try {
    if (!token || !token.expiresAt) {
      return false;
    }

    const expiresAt = moment(token.expiresAt);
    const now = moment();

    // If token expires in less than 5 minutes, refresh it
    if (expiresAt.diff(now, 'minutes') < 5) {
      console.log("Token expired or expiring soon, refreshing...");
      const payload = JSON.stringify({
        refreshToken: token.refreshToken
      });
      const myInit1 = {
        body: { data: payload || {} },
        queryStringParameters: {
        apiId: `${clientId}ApiId`,
        apiKey: `${clientId}ApiKey`,
        clientId: clientId
      },
      };
      return await API.post("developerApi", "/refreshToken", myInit1);
    } else {
      console.log("Token still valid, expires in", expiresAt.diff(now, 'minutes'), "minutes");
      return token;
    }
  } catch (err) {
    console.log("error checking token is valid", err);
    return false;
  }
}

export const getToken = async (clientId, organizationId) => {
  try {
    const payload = JSON.stringify({
      organizationId: organizationId
    });
    const myInit1 = {
      body: { data: payload || {} },
      queryStringParameters: {
        apiId: `${clientId}ApiId`,
        apiKey: `${clientId}ApiKey`,
        clientId: clientId
      },
    };
    return await API.post("developerApi", "/token", myInit1)
  } catch (err) {
    console.log("error getting token", err);
    return null;
  }
}

export const getOffersByToken = async (token) => {
  try {
    const promo = getPromotionId();
    const myInit1 = {
        queryStringParameters: {
          token,
          promotionId: promo,
        },
      };
      return await API.get("developerApi", "/offers2", myInit1)
  } catch (err) {
    console.log("error getting offers by token", err);
    return null;
  }
}

export const getRoles = async (clientId, token) => {
  try {
    const myInit1 = {
      queryStringParameters: {
        apiId: `${clientId}ApiId`,
        apiKey: `${clientId}ApiKey`,
        clientId: clientId,
        token: token
      },
    };
    return await API.get("developerApi", "/roles-channels", myInit1)
  } catch (err) {
    console.log("error getting roles", err);
    return null;
  }
}
export const getOffersByChannel = async (clientId, channel, elevatedToken = undefined) => {
  try {
    const promo = getPromotionId();
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          promotionId: promo,
          channel: channel,
          token: elevatedToken
        },
      };
      return await API.get("developerApi", "/offers", myInit1)
  } catch (err) {
    console.log("error getting loan by id", err);
    return null;
  }
}

export const getDisclosures = async (clientId) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };
      return await API.get("developerApi", "/disclosures", myInit1)
  } catch (err) {
    console.log("error getting current disclosures", err);
    return null;
  }
}

export const getLoanById = async (clientId, loanId) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.get("developerApi", "/loanById", myInit1)
  } catch (err) {
    console.log("error getting loan by id", err);
    return null;
  }
}

export const getLoanByTags = async (clientId, tags) => {
  try {
    const loan = await Promise.all(tags.map(async (tag) => {
      const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          tag: tag
        },
      };
      const loanFound = await API.get("developerApi", "/loanByTag", myInit1)
         return {loan: loanFound, tag: tag};
    }));
    return loan.find((l) => l.loan.data.length === 1);
  } catch (err) {
    console.log("error getting loan by tag", err);
    return {loan: null, tag: ""};
  }
}

export const getLoanByTag = async (clientId, tag) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          tag: tag
        },
      };
      return await API.get("developerApi", "/loanByTag", myInit1)
  } catch (err) {
    console.log("error getting loan by tag", err);
    return false;
  }
}

export const deleteTagByLoanId = async (clientId, loanId, tag) => {
  try {
    const payload = JSON.stringify({
        tags: [
          tag
        ]
    });
    const myInit1 = {
      body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.post("developerApi", "/deleteTag", myInit1)
  } catch (err) {
    console.log("error deleting tag", err);
    return false;
  }
}

export const addTagByLoanId = async (clientId, loanId, tag) => {
  try {
    const payload = JSON.stringify({
        tags: [
          tag
        ]
    });
    const myInit1 = {
      body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.post("developerApi", "/addTag", myInit1)
  } catch (err) {
    console.log("error adding tag", err);
    return false;
  }
}

export const applyForLoan = async (clientId, payload) => {
  try {
    const myInit1 = {
      body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };
      return await API.post("developerApi", "/submitLoan", myInit1)
  } catch (err) {
    console.log("error submitting loan application", err);
    return null;
  }
}

export const changeOrders = async (clientId, loanId, payload) => {
  try {
    const myInit1 = {
      body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.post("developerApi", "/changeOrders", myInit1)
  } catch (err) {
    console.log("error submitting change order", err);
    return false;
  }
}

export const requestLoanDocuments = async (clientId, loanId) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.post("developerApi", "/requestLoanDocuments", myInit1)
  } catch (err) {
    console.log("error requesting loan documents", err);
    return false;
  }
}

export const getCategories = async (clientId, token) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          token
        },
      };
      return await API.get("developerApi", "/categories", myInit1)
  } catch (err) {
    console.log("error getting categories", err);
    return false;
  }
}

export const getLimitations = async (clientId, elevatedToken = undefined) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          token: elevatedToken
        },
      };
      return await API.get("developerApi", "/limitations", myInit1)
  } catch (err) {
    console.log("error getting limitations", err);
    return false;
  }
}

const getPromotionId = () => {
  // if (host.includes("sandbox") || (host.includes("localhost"))) {
  if (host.includes("sandbox")) {
    return sandbox_promotionId;
  } else  {
    return prod_promotionId;
  }
}

export const getPayment = async (clientId, offerId, loanAmount, enrollments, elevatedToken = undefined) => {
    try {
    const promo = getPromotionId();
    const autopay = enrollments && enrollments.length !== 0 && enrollments.includes("AUTOPAY");
    let myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          amount: loanAmount,
          offerId: offerId,
          token: elevatedToken
        },
      };
      if (autopay) myInit1.queryStringParameters = {...myInit1.queryStringParameters, promotionId: promo };
      console.log(autopay, enrollments, myInit1);
      return await API.get("developerApi", "/payments", myInit1)
  } catch (err) {
    console.log("error getting payments", err);
    return false;
  }
}

export const getOfferByLoanId = async (clientId, loanId) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.get("developerApi", "/offersByLoanId", myInit1)
  } catch (err) {
    console.log("error getting offer by loan id", err);
    return false;
  }
}

export const getLoanStatus = async (clientId, loanId) => {
  try {
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          loanId: loanId
        },
      };
      return await API.get("developerApi", "/loanStatus", myInit1)
  } catch (err) {
    console.log("error getting loan status", err);
    return false;
  }
}

export const getUsers = async (clientId, elevatedToken = undefined) => {
  try {
    const myInit1 = {
      queryStringParameters: {
        apiId: `${clientId}ApiId`,
        apiKey: `${clientId}ApiKey`,
        clientId: clientId,
        token: elevatedToken
      },
    };
    return await API.get("developerApi", "/users", myInit1)
  } catch (err) {
    console.log("error getting users", err);
    return false;
  }
}

export const getUserVerificationUrl = async (clientId, userId, elevatedToken = undefined) => {
  try {
    const myInit1 = {
      queryStringParameters: {
        apiId: `${clientId}ApiId`,
        apiKey: `${clientId}ApiKey`,
        clientId: clientId,
        userId: userId,
        token: elevatedToken
      },
    };
    return await API.get("developerApi", "/users/verification-url", myInit1)
  } catch (err) {
    console.log("error getting user verification url", err);
    return false;
  }
}

export const getUserById = async (clientId, userId, elevatedToken = undefined) => {
  try {
    // get userById
    const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          userId: userId,
          token: elevatedToken
        },
      };
    return await API.get("developerApi", "/users", myInit1)
  } catch (err) {
    console.log("error getting user by id", err);
    return false;
  }
}

export const addChannelsToUser = async (clientId, states, sUserId) => {
  let channelsMap = [];
  channelsMap = states.map((st) => {
    let stateMap = [];
    stateMap = st.channels.map((ch) => {
      return  [
        ...stateMap,
        `${st.code}_${ch}`
      ]
    })
    return [
      ...channelsMap,
      ...stateMap.flat()
    ]
  });
  const allChannels = channelsMap.flat();
  try {
        const payload = JSON.stringify({
          channels: allChannels
        });
        const myInit = {
          body: { data: payload || {} },
          queryStringParameters: {
            apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
            userId: sUserId
          },
        };
        return await API.post("developerApi", "/user-channels", myInit);
    } catch (err) {
        console.log("error updating channels", err);
    }
}

const trimAndRemoveSpaces = (str) => {
  // Trim leading and trailing spaces
  str = str.trim();

  // Remove spaces within the string
  str = str.replace(/\s+/g, '');

  return str;
}

export const addLicenseToUser = async (clientId, sUserId, license, state) => {
  try {
        const payload = JSON.stringify({
          id: trimAndRemoveSpaces(license),
          appliesTo: state
        });
        const myInit = {
           body: { data: payload || {} },
           queryStringParameters: {
           apiId: `${clientId}ApiId`,
           apiKey: `${clientId}ApiKey`,
           clientId: clientId,
           userId: sUserId
          },
        };
        return await API.post("developerApi", "/user-license", myInit);
    } catch (err) {
      console.log("error updating user license", err);
       return("Error");
    }
}

export const getStates = async (clientId) => {
    try {
      const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };

      // get states
     return await API.get("developerApi", "/states", myInit0)
    } catch (err) {
      console.log("error getting states", err);
      return false;
    }
  }

export const getChannels = async (clientId, state, elevatedToken = undefined) => {
    try {
      const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          state: state || '',
          token: elevatedToken
        },
      };
      // get states
     return await API.get("developerApi", "/channelsByState", myInit0)
    } catch (err) {
      console.log("error getting channels", err);
      return false;
    }
  }

export const getOffersByCategory = async (clientId, categoryId, state, env, elevatedToken = undefined) => {
    try {
      const promo = getPromotionId();
      const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          categoryId: categoryId,
          state: state || '',
          env: env,
          promotionId: promo,
          token: elevatedToken
        },
      };
      // get states
     return await API.get("developerApi", "/offersByCategory", myInit0)
    } catch (err) {
      console.log("error getting offers", err);
      return false;
    }
  }

export const notifyAdminErrorMessage = async (app, id, error, notifySlack = false) => {
  try {
    if (notifySlack) {
      console.log("sending email", app);
      const myParams = {
        queryStringParameters: {
          formUrl: app ? app.formUrl : "",
          clientId: app ? app.clientId : "",
          id: id,
          error: error,
          notifySlack: notifySlack
        }
      };
      await API.post("developerApi", "/notifyAdminErrorMessage", myParams);
    } else {
      return null;
    }
  } catch (err) {
    console.log("Error Notifying Admin:", err);
  }
}

export const updateNotesRequest = async (req, message ) => {
    try {
        let note = req.notes;
        if (note !== null && note.trim() !== "") note = note.concat("\n");
        const _app = { ...req, notes: note.concat(dateTimeStr(Date.now())).concat(" - " + message) };
        await API.graphql(graphqlOperation(updateRequests, { input: _app }));
    } catch (err) {
        console.log("Error updating Request", err);
    }
  }

  export const createUser = async (clientId, payload, elevatedToken = undefined) => {
    try {
      const myInit1 = {
        body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          token: elevatedToken
        },
      };
      return await API.post("developerApi", "/create-user", myInit1)
    } catch (err) {
      console.log("error creating user", err);
      return false;
    }
  }

  export const userChannels = async (clientId, userId, payload, elevatedToken = undefined) => {
    try {
      const myInit1 = {
        body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          userId: userId,
          token: elevatedToken
        },
      };
      return await API.post("developerApi", "/user-channels", myInit1)
    } catch (err) {
      console.log("error updating user channels", err);
      return false;
    }
  }

  export const getUserByEmail = async (clientId, email, elevatedToken = undefined) => {
    try {
      const myInit1 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          email: encodeURIComponent(email),
          token: elevatedToken
        },
      };
      return await API.get("developerApi", "/users", myInit1)
    } catch (err) {
      console.log("error getting user by email", err);
      return false;
    }
  }

  export const postLoanShare = async (clientId, payload, elevatedToken = undefined) => {
    try {
      const myInit1 = {
        body: { data: payload || {} },
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          token: elevatedToken
        },
      };
      return await API.post("developerApi", "/loans-share", myInit1)
    } catch (err) {
      console.log("error posting loan share", err);
      return false;
    }
  }